import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { translateOutsideReact } from '@/i18n/translateOutsideReact';
import { downloadBlob } from '@/utils/downloadBlob';
import { handleError } from '@/utils/handleError';

export class Sie4ExportApiClient {
  /**
   * Export all fiscal years as a ZIP of SIE4 files.
   * Downloads file directly in browser.
   * @param companyName Used to derive the ZIP filename
   */
  static async exportSie4(companyName: string): Promise<void> {
    try {
      const { data, error } = await supabase.functions.invoke('sie4-export-api', {
        body: { action: 'exportSie4' },
      });

      if (error) {
        await handleError(error, translateOutsideReact('consultantErrors.fallback.failedToExportData'), 'exportSie4');
        return;
      }

      const sanitized = companyName.replace(/[^a-zA-Z0-9-_åäöÅÄÖ\s]/g, '_').replace(/\s+/g, '_');
      const filename = `${sanitized}_sie4_export.zip`;

      downloadBlob(data, filename, 'application/zip');

      toast.success(translateOutsideReact('consultantToasts.api.sie4Exported'));
    } catch (error) {
      await handleError(error, translateOutsideReact('consultantErrors.fallback.failedToExportData'), 'exportSie4');
      throw error;
    }
  }
}
